














































import { defineComponent, computed } from "@vue/composition-api";
import OccSelectboxDate from "@/components/Atoms/OccSelectboxDate/index.vue";
import OccSelectbox from "@/components/Atoms/OccSelectbox/index.vue";
import PopoverSelectBox from "@/components/Atoms/Forms/PopoverSelectBox/index.vue";
import ChartRadioButton from "@/components/Atoms/ChartRadioButton/index.vue";
import dayjs from "dayjs";

export default defineComponent({
  name: "ChartFilter",
  components: {
    OccSelectboxDate,
    PopoverSelectBox,
    OccSelectbox,
    ChartRadioButton
  },
  props: {
    query: {
      type: Object,
      default: () => {
        return {
          eventId: null,
          showCategory: "0",
          startDate: dayjs()
            .subtract(1, "months")
            .format("YYYY/MM/DD"),
          endDate: dayjs()
            .subtract(1, "days")
            .format("YYYY/MM/DD"),
          period: "week"
        };
      }
    },
    events: {
      type: Array,
      default: () => [{ event_id: null, title: "", grade: "" }]
    },
    initEvent: {
      type: Number,
      default: 0
    },
    selectDateMinDate: {
      type: [String, Date],
      required: true
    },
    selectDateMaxDate: {
      type: [String, Date],
      required: true
    }
  },
  setup(props, { emit }) {
    const curShowCategory = computed(() => props.query.showCategory);
    const curStartDate = computed(() => props.query.startDate);
    const curEndDate = computed(() => props.query.endDate);
    const curPeriod = computed(() => props.query.period);
    const curEventId = computed(() => props.query.eventId);
    const initEventId = computed(() => props.initEvent);

    const eventList = computed(() => {
      return props.events?.map(e => {
        const el = e as { grade: string; title: string; event_id: number };
        return { label: `【${el.grade}】${el.title}`, value: el.event_id };
      });
    });

    // TODO: バックエンド改善後に復旧する
    // const selectBusinessList = ref<BusinessSort[]>([
    //   {
    //     label: "自社のみ表示",
    //     value: "0"
    //   },
    //   {
    //     label: "業界平均と比較",
    //     value: "1"
    //   }
    // ]);

    const setPeriod = (value: string) => {
      emit("setPeriod", value);
    };

    const onChangeEvent = (value: number) => {
      emit("changeEvent", value);
    };

    const onChangeStartDate = (value: string) => {
      if (!value) return;
      emit("setStartDate", value);
    };

    const onChangeEndDate = (value: string) => {
      if (!value) return;
      emit("setEndDate", value);
    };

    const onChangeBusinessType = (value: string) => {
      emit("setBusinessType", value);
    };

    return {
      curEventId,
      initEventId,
      curStartDate,
      curEndDate,
      curPeriod,
      curShowCategory,
      eventList,
      onChangeEvent,
      onChangeStartDate,
      onChangeEndDate,
      onChangeBusinessType,
      setPeriod
    };
  }
});
